export default __webpack_public_path__ + "static/media/poster.5bb885a7.png";